import request from "@/utils/request";

export function abcPCPay(data) {
  return request({
    url: '/osp/pay/abcPay',
    method: 'post',
    data: data
  })
}

export function abcTrustPay(data){
  return request({
    url:'/osp/pay/trustPay',
    method:'post',
    data:data
  })
}

export function queryPayRecordList(data){
  return request({
    url:'/osp/payRecord/queryPageList',
    method:'post',
    data:data
  })
}

// export function queryAbcPayStatus(data){
//   return request({
//     url:'/osp/payQuery/queryAbcPayStatus',
//     method:'post',
//     data:data
//   })
// }

export function gateWatB2C(data){
  return request({
    url:'/osp/pay/gateWatB2C',
    method:'post',
    data:data
  })
}

export function repairPay(data){
  return request({
    url:'/osp/pay/repairPay',
    method:'post',
    data:data
  })
}

export function getSupportPayWay(data){
  return request({
    url:'/osp/pay/supportPayWay',
    method:'post',
    data:data
  })
}

export function getTaxInfo(data){
  return request({
    url:'/osp/pay/getTaxInfo',
    method:'post',
    data:data
  })
}

export function getTradeInvla(data){
  return request({
    url:'/osp/pay/getTradeInvla',
    method:'post',
    data:data
  })
}

export function getSubmitBillAmount(data){
  return request({
    url:'/osp/pay/getSubmitBillAmount',
    method:'post',
    data:data
  })
}
